(function () {
  // Define UI8 Application
  angular
    .module("UI8", [
      "ngResource",
      "ngCookies",
      "express-csrf",
      "UI8.filters",
      "UI8.services",
      "UI8.resources",
      "UI8.directives",
      "UI8.controllers",
      "UI8.components",
      "credit-cards",
      "ngFileUpload",
      "relativeDate",
    ])
    .config([
      "$provide",
      function ($provide) {
        $provide.decorator("$browser", [
          "$delegate",
          function ($delegate) {
            $delegate.onUrlChange = function () {};
            $delegate.url = function () {
              return "";
            };
            return $delegate;
          },
        ]);
      },
    ])
    .config(function ($httpProvider) {
      $httpProvider.defaults.headers.common["X-Requested-With"] =
        "XMLHttpRequest";
      $httpProvider.defaults.withCredentials = true;
    })
    .config([
      "$compileProvider",
      function ($compileProvider) {
        $compileProvider.debugInfoEnabled(false);
      },
    ])
    .run(function ($rootScope, $location, $timeout, SessionService) {
      // vendor.min.js is deferred, so the inline UI8 blob in the layout runs
      // before uuidv4 exists; mint the checkout idempotency key here instead.
      if (!window.UI8.idempotencyKey && window.uuidv4)
        window.UI8.idempotencyKey = window.uuidv4();

      if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
      } else {
        window.addEventListener("unload", function () {
          //set scroll position to the top of the page.
          window.scrollTo(0, 0);
        });
      }

      function hasSearchParam() {
        return /[?&]search=/.test(window.location.search);
      }

      function openSearch(letter) {
        $rootScope.showSearch = true;
        if (letter != null) {
          localStorage.removeItem("srch:search-state");
          sessionStorage.removeItem("top:search");
          sessionStorage.removeItem("count:search");
          $rootScope.searchTerm = letter;
        }
        $timeout(function () {
          $rootScope.$digest();
        });
        // The $browser decorator above decouples $location from the real
        // URL on these pages, so stamp ?search=1 natively — it's what lets
        // Back (after leaving via a drawer link) restore the search.
        if (!hasSearchParam()) {
          var stamped = new URL(window.location.href);
          stamped.searchParams.set("search", "1");
          history.pushState(null, "", stamped.toString());
        }
        $("body").css("overflow-y", "hidden");
      }

      window.openSearch = openSearch;

      // Explicit close (X / ESC): the modal's $location strip is inert
      // here (see above), so drop the param natively.
      $rootScope.$on("search:closed", function () {
        if (hasSearchParam()) {
          var stripped = new URL(window.location.href);
          stripped.searchParams.delete("search");
          history.replaceState(null, "", stripped.toString());
        }
      });

      // While scrolling, product cards ignore the pointer so hover
      // states can't flash as the page moves under the cursor (also
      // skips hover hit-testing/style recalc mid-scroll). Capture
      // catches nested scrollers like the search modal.
      var scrollIdleTimer = null;
      window.addEventListener(
        "scroll",
        function () {
          if (scrollIdleTimer === null)
            document.body.classList.add("is-scrolling");
          clearTimeout(scrollIdleTimer);
          scrollIdleTimer = setTimeout(function () {
            scrollIdleTimer = null;
            document.body.classList.remove("is-scrolling");
          }, 150);
        },
        { passive: true, capture: true }
      );

      document.addEventListener("keydown", function (e) {
        var invalids = ["input", "select", "textarea"];

        if (invalids.indexOf(e.target.nodeName.toLowerCase()) !== -1) return;

        // Type-to-search stays off while the cart drawer is open
        if (document.querySelector(".header__cell--cart.active")) return;

        if ($rootScope.showSearch) {
          $("#search-input").focus();
        }

        // Ignore keypresses when Cmd, Ctrl, or Alt are pressed
        if (e.altKey || e.ctrlKey || e.metaKey) return;

        // Only react to numbers and letters
        if (e.keyCode < 48 || e.keyCode > 90) return;

        var letter = String.fromCharCode(e.keyCode);
        if (!e.shiftKey) letter = letter.toLowerCase();

        if (!$rootScope.showSearch) {
          return openSearch(letter);
        }
      });

      if (!$rootScope.user) {
        SessionService.setCurrentUser();
      }

      window.addEventListener("popstate", function updateWindowLocation() {
        window.removeEventListener("popstate", updateWindowLocation);
        window.location = window.location.href;
      });

      if (hasSearchParam()) openSearch();

      // bfcache restore skips the boot check above; the overlay was hidden
      // by leaveSearch() before navigating away, so reopen it here.
      window.addEventListener("pageshow", function (e) {
        if (e.persisted && hasSearchParam() && !$rootScope.showSearch)
          openSearch();
      });

      if ($location.search().support && window.$chatwoot)
        window.$chatwoot.toggle("open");
    });

  // Application Namespaces
  angular.module("UI8.filters", []);
  angular.module("UI8.services", []);
  angular.module("UI8.resources", []);
  angular.module("UI8.directives", []);
  angular.module("UI8.controllers", []);
  angular.module("UI8.components", []);
})();
